var faqs = new function () {
    this.cache = {};
    this.doLoad = function (event, el) {
        var $el = $(el);
        if ($el.is('select') || $el.is('a') || $el.is('button')) {
            if ($el.data('page')) {
                $('.faqs-page').val($el.data('page'));
            }
            if ($el.is('button') && $('.refine').hasClass('is-active')) {
                $('.refine__apply').trigger('click');
            }
            listFilter.doStateChange();
        }
        this.doAjaxLoad();
    };
    this.setAnswerHelpful = function (event, el) {
        var $wrapper = $(el).closest('.faq-question'),
            data = {
                action: 'flogas_faqs_helpful',
                id: $wrapper.data('id'),
                helpful: $(el).data('type'),
                _wpnonce: $wrapper.data('nonce')
            };
        if (typeof this.xhr == 'object') this.xhr.abort();
        this.xhr = jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'json',
            data: data,
            success: function (json) {
                $wrapper.find('.faq-question__question').addClass('hide');
                $wrapper.find('.faq-question__response--' + (data.helpful == '0' ? 'un' : '') + 'helpful').removeClass('hide');
            }
        });
    };
    this.setLoading = function (loading) {
        listFilter.doScrollTop();
        $('.faqs__list')[(loading ? 'add' : 'remove') + 'Class']('loading');
        $('.faqs-keyword, .faqs-category, .faqs-search').prop('disabled', loading);
    };
    this.doAjaxLoad = function () {
        var $faqsList = $('.faqs-list'),
            ajaxData = {
                action: 'flogas_faqs_get_full',
                keyword: $('.faqs-keyword').val().trim(),
                category: $('.faqs-category').val(),
                page: $('.faqs-page').val(),
                _wpnonce: $faqsList.data('nonce')
            },
            cacheKey = ajaxData.keyword + ':' + ajaxData.category + ':' + ajaxData.page;
        faqs.setLoading(true);
        if (typeof faqs.cache[cacheKey] != 'undefined') {
            $faqsList.html(faqs.cache[cacheKey]);
            faqs.setLoading(false);
            data.setCss();
        } else {
            if (typeof this.xhr == 'object') this.xhr.abort();
            this.xhr = jQuery.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: ajaxData,
                success: function (json) {
                    faqs.cache[cacheKey] = json.data;
                    faqs.setLoading(false);
                    $faqsList.html(json.data);
                }
            });
        }
    };
    this.doKeyup = function (event, el) {
        var keyCode = (event.keyCode ? event.keyCode : event.which);
        if (keyCode == 13) {
            event.preventDefault();
            $('.faqs-search').trigger('click');
        }
    };

    this.doResetFilters = function (event, el) {
        $('.faqs-category, .faqs-keyword').val('');
        $('.faqs-category').trigger('change');
    };
};
if (typeof listFilter != 'undefined') {
    listFilter.setPageClass('.faqs-page');
    listFilter.setVariables({
        category: {prefix: 'category', identifier: '.faqs-category'},
        keyword: {queryString: true, identifier: '.faqs-keyword'},
    });
}
window.onpopstate = function(event) {
    listFilter.setParamsFromUrl();
    faqs.doAjaxLoad();
};